module.exports = __webpack_public_path__ + "static/media/Rexroth-Logo_RGB_M.e685d131.png";